import angular from "angular";

import SubscriptionService from "./SubscriptionService";
import Assert from "tbAssert";

import OfficeTypeDataServiceModule from "../OfficeTypeDataService";

const mOfficeTypeDataSvc = new WeakMap();
const mQSvc = new WeakMap();
const mLogSvc = new WeakMap();

class OfficeTypeSubscriptionService extends SubscriptionService {
    constructor($q, $log, OfficeTypeData) {
        super();

        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(OfficeTypeData != null, "Assertion Failure: Missing OfficeType Data Service Dependency");

        mQSvc.set(this, $q);
        mLogSvc.set(this, $log);
        mOfficeTypeDataSvc.set(this, OfficeTypeData);
    }

    getTarget(officeTypeTargetId) {
        let officeTypeRetrievalPromise =
            mOfficeTypeDataSvc.get(this)
                .getCore({officeTypeId: officeTypeTargetId})
                .$promise
                .then(
                    (retrievedOfficeType) => retrievedOfficeType.result,
                    (errorResponse) => mQSvc.get(this).reject(errorResponse)
                );

        return officeTypeRetrievalPromise;
    }

    getTargetBatch(officeTypeTargetIds) {
        let officeTypeRetrievalPromises = officeTypeTargetIds.map((tgtId) => this.getTarget(tgtId));

        return mQSvc.get(this).all(officeTypeRetrievalPromises);
    }

    addSubscription(recipientId, officeTypeTargetId) {
        let subAddPromise = mOfficeTypeDataSvc.get(this).addSubscription({
                officeTypeId: officeTypeTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedOfficeTypeResource) => {
                    let updatedOfficeType = updatedOfficeTypeResource.result;
                    let selectedSubs = updatedOfficeType.officeTypeSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        mQSvc.get(this).reject("Failed to add subscription.");
                    }
                    else {
                        return true;
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subAddPromise;
    }

    removeSubscription(recipientId, officeTypeTargetId) {
        let subDelPromise = mOfficeTypeDataSvc.get(this).removeSubscription({
                officeTypeId: officeTypeTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedOfficeTypeResource) => {
                    let updatedOfficeType = updatedOfficeTypeResource.result;
                    let selectedSubs = updatedOfficeType.officeTypeSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        return true;
                    }
                    else {
                        mQSvc.get(this).reject("Failed to remove subscription.");
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subDelPromise;
    }
}

OfficeTypeSubscriptionService.$inject = [ "$q", "$log", "OfficeTypeData" ];

export default angular
    .module("trackerbase-app.services.subscription-data-adapters.office-type-subscription-service",[
        OfficeTypeDataServiceModule
    ])
    .service("OfficeTypeSubscriptionData", OfficeTypeSubscriptionService)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/OfficeTypeSubscriptionService.js
// module id = vJOh
// module chunks = 1